<template>
  <div class="card">
    <div class="card-body">
      <h2 class="mt-3 mb-2">Setup your Import</h2>
      <p class="mb-4 text-muted" v-if="showActions">
        Once you pick an action and location, you can upload your file.
      </p>
      <form class="mb-0">
        <div v-if="showActions">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>
                  Choose an invitation
                  <span class="text-muted"></span>
                </label>
                <small class="form-text text-muted"
                  >After the customers are imported, what would you like to do?</small
                >
                <select
                  class="form-control form-control-lg"
                  data-testid="customer-import-action-select"
                  v-model="action"
                >
                  <option value selected disabled>Choose one</option>
                  <option value="none">Do nothing</option>
                  <option value="survey">Invite them to leave a survey</option>
                  <!-- <option value="review">
                  Invite them to leave a review
                    </option>-->
                </select>
              </div>
            </div>
          </div>
          <hr class="mt-3 mb-4" />
        </div>
        <CustomerImportLocationDropdown v-on:setLocation="setLocation" />
        <hr class="mt-3 mb-4" />
        <div class="form-group">
          <label class="mb-1">Marketing Eligibility</label>
          <small class="form-text text-muted"
            >Marketing opt-in was previously gathered, making these customers eligible to receive
            campaigns.</small
          >
          <select
            class="form-control"
            data-toggle="select"
            data-testid="customer-import-marketing-select"
            v-model="marketingOptIn"
          >
            <option :value="undefined" selected disabled>Choose one</option>
            <option :value="true">Eligible to receive marketing</option>
            <option :value="false">Not eligible</option>
          </select>
        </div>
        <hr v-if="action && locationId && marketingOptIn !== undefined" class="mt-4 mb-4" />
        <CustomerImportUpload
          v-if="action && locationId && marketingOptIn !== undefined"
          v-on:finished="startPreflight"
          v-on:parse-error="uploadError = 'parse'"
          v-on:realtime-error="uploadError = 'realtime'"
        />
        <div
          v-if="uploadError === 'parse'"
          class="alert alert-danger"
          role="alert"
          data-testid="customer-import-parse-error"
        >
          We could not read any rows from this file. Please upload a comma delimited CSV without a
          header.
        </div>
        <div
          v-if="uploadError === 'realtime'"
          class="alert alert-danger"
          role="alert"
          data-testid="customer-import-realtime-error"
        >
          We could not connect to live updates. Reload the page and try again.
        </div>
        <div
          v-if="isVerifying"
          class="alert alert-light m-0 d-flex justify-content-center align-items-center"
          role="alert"
          data-testid="customer-import-verifying"
        >
          <b-spinner small label="Spinning" class="mr-1"></b-spinner>
          <h3 class="m-0">We are verifying your uploaded CSV file...</h3>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import TCPAService from '@/services/TcpaService'
import CustomerImportUpload from './CustomerImportUpload'
import CustomerImportLocationDropdown from './CustomerImportLocationDropdown'
import { STATUS } from '@/store/customer-import'

const companyModule = createNamespacedHelpers('company')
const CustomerModule = createNamespacedHelpers('customer')
const customerImportModule = createNamespacedHelpers('customerImport')
const userModule = createNamespacedHelpers('user')

export default {
  name: 'CustomerImportForm',

  components: {
    CustomerImportUpload,
    CustomerImportLocationDropdown
  },

  data: () => ({
    action: '',
    locationId: undefined,
    locations: [],
    marketingOptIn: undefined,
    uploadError: null
  }),

  mounted() {
    if (!this.showActions) {
      this.action = 'none'
    }
  },

  computed: {
    ...userModule.mapState(['onlineUser']),
    ...companyModule.mapState(['activeCompany']),
    ...customerImportModule.mapState(['status']),
    isVerifying() {
      return this.status === STATUS.AWAITING_PREFLIGHT
    },
    showActions() {
      return (
        this.activeCompany._id !== 'ALL_COMPANIES' &&
        this.activeCompany.settings.bulkSurveyInvitesEnabled
      )
    }
  },

  methods: {
    ...CustomerModule.mapActions(['setImportParams']),
    async startPreflight({ url: fileUrl, rows }) {
      this.uploadError = null
      this.setImportParams({
        fileUrl,
        action: this.action,
        locationId: this.locationId,
        preflight: true,
        marketingOptIn: this.marketingOptIn
      })

      try {
        await this.$store.dispatch('customerImport/startPreflight', { rows, fileUrl })

        await this.saveTcpaCompliance(fileUrl)
      } catch (error) {
        this.$notify({
          title: 'Import failed',
          text: `Please double check your CSV file.`,
          type: 'error'
        })
      }
    },
    async saveTcpaCompliance(fileUrl) {
      await TCPAService.create({
        userId: this.onlineUser._id,
        companyId: this.activeCompany._id,
        locationId: this.locationId,
        contactListUrl: fileUrl
      })
    },
    setLocation(locationId) {
      this.locationId = locationId
    }
  }
}
</script>

<style scoped lang="scss"></style>
